import React from "react";
import { Ban } from "lucide-react";

export default function NoneOption({ selected, onClick, testId, label = "None" }) {
  return (
    <button
      type="button"
      data-testid={testId}
      onClick={onClick}
      className={`sc-card ${selected ? "selected" : ""} flex flex-col items-center justify-center p-4 md:p-5 text-center cursor-pointer`}
      style={{ minHeight: "120px" }}
    >
      <Ban
        size={28}
        strokeWidth={1.4}
        className="sc-icon mb-2"
        style={{ color: selected ? "#2C2A28" : "#B89968" }}
      />
      <span
        className="text-xs md:text-sm font-medium leading-tight"
        style={{ fontFamily: "Manrope, sans-serif", color: "#2C2A28" }}
      >
        {label}
      </span>
    </button>
  );
}
